export default __webpack_public_path__ + "static/media/Budget_Ballin.e8ae9826.gif";